import axios from 'axios';
import React, { useState, useEffect, use } from 'react';
import { useSelector } from 'react-redux';

function QRCodeGenerator() {
      const auth = useSelector((state) => state.authentication);
  const { userData } = auth;
  const [qrImage, setQrImage] = useState('');

  useEffect(() => {
  if (!userData?.token) return;

  // 1. Grabs "https://college.paipetsoft.com" dynamically in production
  const domain = window.location.origin; 
  
  // 2. Combines it to make: "https://college.paipetsoft.com/forms/maintanance-form"
  // (Note: Using your spelling of "maintanance-form" to match your route precisely)
  const currentLiveUrl = `https://docs.google.com/forms/`;

  axios.post(
    `${process.env.REACT_APP_COLLEGE_ERP_API}qr/get-qr`, 
    { formUrl: currentLiveUrl }, 
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userData.token}`
      }
    }
  )
  .then((res) => {
    if (res.data && res.data.success) {
      setQrImage(res.data.qrImage);
    }
  })
  .catch((err) => {
    console.error('Error fetching QR code:', err);
  });

}, [userData?.token]);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h2>Printable QR Code</h2>
      {qrImage ? (
        <div>
          <img src={qrImage} alt="Dynamic Form QR" style={{ width: '350px' }} />
          <br />
          <button onClick={() => window.print()} style={{ marginTop: '20px', padding: '10px 20px' }}>
            Print QR Code
          </button>
        </div>
      ) : (
        <p>Generating QR code...</p>
      )}
    </div>
  );
}

export default QRCodeGenerator;